export default __webpack_public_path__ + "static/SR USA - Safety Data Sheet - Caramel Color (Powders)-3321333db45c2224cfa42d15d7924d53.pdf";